import { useState } from "react";
import toast from "react-hot-toast";
import {
    Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
    Stack, Text, useColorModeValue,
} from "@chakra-ui/react";
import { transferLeadership } from "../groupsApi";
import { InfoBanner } from "../groupsUi";

/**
 * Submits the transfer and surfaces toasts.
 * @param {Object} args - Submission args
 */
async function submitTransfer({ groupId, memberId, setLoading, onClose, onTransferred }) {
    setLoading(true);
    try {
        await transferLeadership(groupId, memberId);
        toast.success("Leadership transféré");
        onTransferred?.();
        onClose();
    } catch (error) {
        const msg = error?.response?.data;
        toast.error(typeof msg === "string" ? msg : "Échec du transfert");
    } finally {
        setLoading(false);
    }
}

/**
 * Body of the transfer confirmation.
 * @param {Object} props - { member }
 */
function DialogBody({ member }) {
    const textColor = useColorModeValue("secondaryGray.800", "whiteAlpha.900");
    return (
        <Stack spacing="16px">
            <InfoBanner>Le précédent leader sera rétrogradé. Le nouveau leader recevra une notification email.</InfoBanner>
            <Text color={textColor} fontSize="0.85rem">
                Promouvoir <strong>{member?.surname || member?.email || "ce membre"}</strong> en tant que leader du groupe ?
            </Text>
        </Stack>
    );
}

/**
 * Confirmation dialog to transfer the group's leadership to a member.
 * @param {Object} props - { groupId, member, onClose, onTransferred }
 */
function TransferLeadershipDialog({ groupId, member, onClose, onTransferred }) {
    const open = Boolean(member);
    const [loading, setLoading] = useState(false);
    const onSubmit = () => submitTransfer({ groupId, memberId: member?.id, setLoading, onClose, onTransferred });

    return (
        <Modal isOpen={open} onClose={onClose} size="md" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Transférer le leadership</ModalHeader>
                <ModalCloseButton />
                <ModalBody><DialogBody member={member} /></ModalBody>
                <ModalFooter gap="8px">
                    <Button variant="ghost" onClick={onClose}>Annuler</Button>
                    <Button colorScheme="brand" onClick={onSubmit} isLoading={loading} loadingText="Transfert...">Confirmer</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default TransferLeadershipDialog;
